import React from 'react';
import { Search } from 'lucide-react';
import './SearchBox.css';

const SearchBox = ({
    value = '',
    onChange,
    placeholder = 'Search...',
    width = "16.667vw",
    iconSize = "0.833vw"
}) => {
    return (
        <div className="search-box" style={{ width }}>
            <Search className="search-icon-small" size={iconSize} />
            <input
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={(e) => onChange && onChange(e.target.value)}
                className="search-connections-input"
            />
        </div>
    );
};

export default SearchBox;